/* eslint-disable linebreak-style */
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 * @param {string} $selector - selector for the slick carousel
 * @param {string} $defaulValues - slick carousel default values
 * @param {string} $responsive - slick carousel responsive values
 */

// Track which carousels have already been set up
var accessibilitySetupCarousels = [];

/**
 * @function
 * @description Sets up global accessibility features for slick carousels
 * @param {jQuery} $slickElement - the initialized slick carousel element
 */
function setupCarouselAccessibility($slickElement) {
    var element = $slickElement[0];
    var isPromoBannerCarousel = $slickElement.hasClass('slick-carousel-promo');

    // Slick wraps slides in unroled .slick-list > .slick-track divs, which sit between
    // the carousel's ARIA role (e.g. role="listbox"/"region") and its required children
    // (role="option"/"group"), tripping "required children" ADA checks. Hide them from
    // the accessibility tree so the role's real children remain its direct owned elements.
    $slickElement.find('.slick-list, .slick-track').attr('role', 'presentation');

    // Prevent double setup
    if (accessibilitySetupCarousels.indexOf(element) !== -1) {
        return;
    }
    accessibilitySetupCarousels.push(element);

    // Fix role="generic" issue on slides by removing the role attribute
    // This ensures tabbable elements inside slides have proper widget roles
    $slickElement.find('.slick-slide').each(function () {
        var $slide = $(this);
        // Remove role="generic" which is not a valid widget role for tabbable elements
        if ($slide.attr('role') === 'generic') {
            $slide.removeAttr('role');
        }
    });

    // Function to update focusable elements based on slide visibility
    function updateFocusableElements() {
        // Fix any new slides that might have role="generic"
        $slickElement.find('.slick-slide[role="generic"]').removeAttr('role');

        // Make all focusable elements in inactive slides not tabbable
        $slickElement.find('.slick-slide:not(.slick-active)').find('a, button, input, select, textarea, [tabindex="0"]').attr('tabindex', '-1');
        // Make focusable elements in active slides tabbable
        $slickElement.find('.slick-slide.slick-active').find('a, button, input, select, textarea, [tabindex="-1"]').attr('tabindex', '0');
    }

    // Update on initialization
    updateFocusableElements();

    // Handle afterChange event to move focus when navigating via keyboard
    $slickElement.on('afterChange', function (event, slick, currentSlide) {
        // Update focusable elements after slide change
        updateFocusableElements();

        if (isPromoBannerCarousel) {
            var $promoSlide = $(slick.$slides.get(currentSlide));
            var $focusAnchor = $promoSlide.find('a').filter(':visible').first();

            if ($focusAnchor.length && $slickElement[0].contains(document.activeElement)) {
                setTimeout(function () {
                    $focusAnchor[0].focus();
                }, 150);
            }

            return;
        }

        // Check if the change was triggered by keyboard interaction
        if (event.originalEvent && (event.originalEvent.type === 'keydown' || event.originalEvent.type === 'keyup')) {
            var $currentSlide = $(slick.$slides.get(currentSlide));
            var $focusableElement = $currentSlide.find('a, button, [tabindex="0"]').not('.shop-the-look-gallery-cta').first();

            if ($focusableElement.length) {
                setTimeout(function () {
                    $focusableElement[0].focus();
                }, 150);
            }
        }
    });

    // Handle keyboard navigation on arrow buttons
    $slickElement.on('keydown', '.slick-arrow, .slide-arrow, .prev-arrow, .next-arrow', function (event) {
        // Only handle Enter (13) and Space (32) key presses
        if (!(event.which === 13 || event.which === 32)) {
            return;
        }

        // Prevent default to avoid scrolling on space
        event.preventDefault();

        // Trigger click to navigate
        $(this).trigger('click');
    });

    // Handle click events on arrow buttons (including triggered clicks from keyboard)
    $slickElement.on('click', '.slick-arrow, .slide-arrow, .prev-arrow, .next-arrow', function () {
        if (isPromoBannerCarousel) {
            return;
        }

        // After navigation, move focus to the first focusable element in the new slide
        setTimeout(function () {
            var $slickList = $slickElement.find('.slick-list');
            var $currentSlide = $slickList.find('.slick-active:first');
            var $focusableElement = $currentSlide.find('a, button, [tabindex="0"]').not('.shop-the-look-gallery-cta').first();

            if ($focusableElement.length) {
                $focusableElement[0].focus();
            }
        }, 150);
    });

    // Ensure arrow buttons are keyboard accessible
    $slickElement.find('.slick-arrow, .slide-arrow').each(function () {
        var $arrow = $(this);

        // Ensure button type if not already set
        if ($arrow.is('button') && !$arrow.attr('type')) {
            $arrow.attr('type', 'button');
        }

        // Ensure proper aria-label if not present
        if (!$arrow.attr('aria-label')) {
            if ($arrow.hasClass('slick-prev') || $arrow.hasClass('prev-arrow')) {
                $arrow.attr('aria-label', 'Previous slide');
            } else if ($arrow.hasClass('slick-next') || $arrow.hasClass('next-arrow')) {
                $arrow.attr('aria-label', 'Next slide');
            }
        }
    });
}

exports.init = function ($selector, $defaulValues, $responsive) {
    var config = $defaulValues;
    if ($responsive) {
        config.responsive = [
            {
                breakpoint: 992,
                settings: $responsive
            }
        ];
    }

    // Initialize slick carousel
    var $notInitialized = $selector.not('.slick-initialized');
    $notInitialized.slick(config);

    // Set up accessibility features for newly initialized carousels
    // Use setTimeout to ensure slick is fully initialized
    setTimeout(function () {
        $notInitialized.filter('.slick-initialized').each(function () {
            setupCarouselAccessibility($(this));
        });
    }, 100);
};

// Export setupCarouselAccessibility for use by other modules
exports.setupAccessibility = setupCarouselAccessibility;
